import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useParams, Link } from 'react-router-dom';
import {
  FaUserGraduate, FaBriefcase, FaBuilding, FaGraduationCap, FaEnvelope,
  FaLinkedin, FaGlobe, FaMapMarkerAlt, FaPhone, FaCalendarAlt, FaIndustry,
  FaUserPlus, FaComment, FaArrowLeft, FaCertificate, FaMedal, FaTrophy,
  FaChalkboardTeacher, FaBook, FaCode, FaPalette, FaMicroscope, FaChartLine,
  FaRobot, FaLightbulb, FaGithub, FaTwitter, FaProjectDiagram, FaUsers,
  FaPercentage, FaHandshake, FaSuitcase, FaUniversity, FaCogs
} from 'react-icons/fa';

// Enhanced sample data

const enhancedAlumniData = [
  {
    id: "1",
    fullName: "Aarav Patel",
    email: "aarav.patel@email.com",
    profileImage: "https://randomuser.me/api/portraits/men/1.jpg",
    graduationYear: 2018,
    major: "Computer Science and Engineering",
    university: "Indian Institute of Technology, Bombay",
    company: "Tata Consultancy Services",
    industry: "Information Technology",
    currentPosition: "Senior Software Engineer",
    location: "Mumbai, Maharashtra",
    skills: ["Java", "Spring Boot", "Microservices", "Docker", "Kubernetes"],
    achievements: "Led development of a core banking system used by 5 major Indian banks",
    bio: "Passionate about creating scalable software solutions and mentoring junior developers.",
    projects: ["Digital Payment Gateway", "Cloud Migration for Financial Services"],
    languages: ["English", "Hindi", "Gujarati"],
    interests: ["Artificial Intelligence", "Cricket", "Classical Music"],
    socialMedia: {
      linkedin: "linkedin.com/in/aaravpatel",
      github: "github.com/aaravp",
      twitter: "twitter.com/aaravtech"
    }
  },
  {
    id: "2",
    fullName: "Priya Sharma",
    email: "priya.sharma@email.com",
    profileImage: "https://randomuser.me/api/portraits/women/2.jpg",
    graduationYear: 2019,
    major: "Data Science",
    university: "Indian Statistical Institute, Kolkata",
    company: "Flipkart",
    industry: "E-commerce",
    currentPosition: "Data Scientist",
    location: "Bangalore, Karnataka",
    skills: ["Python", "Machine Learning", "SQL", "Tableau", "Big Data Analytics"],
    achievements: "Developed an AI model that improved product recommendations by 30%",
    bio: "Data enthusiast passionate about leveraging AI to solve real-world problems in e-commerce.",
    projects: ["Customer Segmentation Model", "Fraud Detection System"],
    languages: ["English", "Hindi", "Bengali"],
    interests: ["Data Visualization", "Badminton", "Travel Photography"],
    socialMedia: {
      linkedin: "linkedin.com/in/priyasharma",
      github: "github.com/priyads",
      twitter: "twitter.com/priyadata"
    }
  },
  {
    id: "3",
    fullName: "Arjun Reddy",
    email: "arjun.reddy@email.com",
    profileImage: "https://randomuser.me/api/portraits/men/3.jpg",
    graduationYear: 2020,
    major: "Mechanical Engineering",
    university: "National Institute of Technology, Tiruchirappalli",
    company: "Mahindra & Mahindra",
    industry: "Automotive",
    currentPosition: "Product Design Engineer",
    location: "Chennai, Tamil Nadu",
    skills: ["CAD", "Finite Element Analysis", "3D Printing", "Project Management", "Six Sigma"],
    achievements: "Key designer for Mahindra's award-winning electric SUV",
    bio: "Innovative engineer passionate about sustainable automotive design and electric vehicles.",
    projects: ["Lightweight Chassis Design", "Electric Vehicle Battery Cooling System"],
    languages: ["English", "Tamil", "Telugu"],
    interests: ["Electric Vehicles", "Robotics", "Classical Dance"],
    socialMedia: {
      linkedin: "linkedin.com/in/arjunreddy",
      github: "github.com/arjunr"
    }
  },
  {
    id: "4",
    fullName: "Zara Khan",
    email: "zara.khan@email.com",
    profileImage: "https://randomuser.me/api/portraits/women/4.jpg",
    graduationYear: 2017,
    major: "Electronics and Communication Engineering",
    university: "Birla Institute of Technology and Science, Pilani",
    company: "Reliance Jio",
    industry: "Telecommunications",
    currentPosition: "Network Engineer",
    location: "Gurgaon, Haryana",
    skills: ["5G Technology", "Network Security", "IoT", "CISCO Networking", "Cloud Computing"],
    achievements: "Led the team that implemented 5G in 3 major Indian cities",
    bio: "Tech enthusiast working on cutting-edge telecom solutions to connect India.",
    projects: ["5G Network Deployment", "IoT-based Smart City Solutions"],
    languages: ["English", "Hindi", "Urdu"],
    interests: ["Emerging Technologies", "Yoga", "Indian Classical Music"],
    socialMedia: {
      linkedin: "linkedin.com/in/zarakhan",
      twitter: "twitter.com/zaratech"
    }
  },
  {
    id: "5",
    fullName: "Vikram Malhotra",
    email: "vikram.malhotra@email.com",
    profileImage: "https://randomuser.me/api/portraits/men/5.jpg",
    graduationYear: 2016,
    major: "Business Administration",
    university: "Indian Institute of Management, Ahmedabad",
    company: "Paytm",
    industry: "Fintech",
    currentPosition: "Product Manager",
    location: "Noida, Uttar Pradesh",
    skills: ["Product Strategy", "Agile Methodologies", "Data Analytics", "UX Design", "Digital Payments"],
    achievements: "Launched a new credit product that acquired 1 million users in 3 months",
    bio: "Passionate about revolutionizing financial services through technology in India.",
    projects: ["UPI 2.0 Integration", "AI-powered Credit Scoring System"],
    languages: ["English", "Hindi", "Punjabi"],
    interests: ["Fintech Innovations", "Stand-up Comedy", "Marathon Running"],
    socialMedia: {
      linkedin: "linkedin.com/in/vikrammalhotra",
      twitter: "twitter.com/vikramproduct"
    }
  },
  {
    id: "6",
    fullName: "Anjali Mehta",
    email: "anjali.mehta@email.com",
    profileImage: "https://randomuser.me/api/portraits/women/6.jpg",
    graduationYear: 2021,
    major: "Chemical Engineering",
    university: "Indian Institute of Technology, Delhi",
    company: "Shell",
    industry: "Energy",
    currentPosition: "Process Engineer",
    location: "New Delhi, Delhi",
    skills: ["Process Optimization", "Catalysis", "Simulation Software", "HSE Management", "Six Sigma"],
    achievements: "Optimized refinery process, reducing waste by 15%",
    bio: "Chemical engineer focused on sustainable energy solutions and green technologies.",
    projects: ["Green Hydrogen Production", "Sustainable Refining Techniques"],
    languages: ["English", "Hindi"],
    interests: ["Renewable Energy", "Sustainable Living", "Yoga"],
    socialMedia: {
      linkedin: "linkedin.com/in/anjalimehta"
    }
  },
  {
    id: "7",
    fullName: "Rohan Verma",
    email: "rohan.verma@email.com",
    profileImage: "https://randomuser.me/api/portraits/men/7.jpg",
    graduationYear: 2015,
    major: "Finance",
    university: "Faculty of Management Studies, Delhi University",
    company: "Goldman Sachs",
    industry: "Finance",
    currentPosition: "Investment Analyst",
    location: "Mumbai, Maharashtra",
    skills: ["Financial Modeling", "Equity Research", "Portfolio Management", "Risk Analysis", "Excel"],
    achievements: "Generated over $2 million in profits for high-net-worth clients",
    bio: "Finance professional with a knack for market analysis and investment strategy.",
    projects: ["Emerging Markets Investment Strategy", "AI-driven Stock Analysis Tool"],
    languages: ["English", "Hindi"],
    interests: ["Stock Market", "Chess", "Public Speaking"],
    socialMedia: {
      linkedin: "linkedin.com/in/rohanverma"
    }
  },
  {
    id: "8",
    fullName: "Meera Iyer",
    email: "meera.iyer@email.com",
    profileImage: "https://randomuser.me/api/portraits/women/8.jpg",
    graduationYear: 2014,
    major: "Architecture",
    university: "School of Planning and Architecture, Delhi",
    company: "L&T Realty",
    industry: "Architecture and Design",
    currentPosition: "Senior Architect",
    location: "Bangalore, Karnataka",
    skills: ["Urban Design", "Sustainable Architecture", "AutoCAD", "Revit", "Project Management"],
    achievements: "Designed an award-winning eco-friendly residential complex",
    bio: "Architect committed to sustainable and innovative urban design solutions.",
    projects: ["Smart City Planning", "Eco-friendly Residential Complex"],
    languages: ["English", "Kannada", "Hindi"],
    interests: ["Green Architecture", "Travel", "Classical Dance"],
    socialMedia: {
      linkedin: "linkedin.com/in/meeraiyer"
    }
  },
  {
    id: "9",
    fullName: "Rahul Desai",
    email: "rahul.desai@email.com",
    profileImage: "https://randomuser.me/api/portraits/men/9.jpg",
    graduationYear: 2013,
    major: "Biomedical Engineering",
    university: "All India Institute of Medical Sciences, Delhi",
    company: "Medtronic",
    industry: "Medical Devices",
     currentPosition: "Senior Architect",
    location: "Bangalore, Karnataka",
    skills: ["Urban Design", "Sustainable Architecture", "AutoCAD", "Revit", "Project Management"],
    achievements: "Designed an award-winning eco-friendly residential complex",
    bio: "Architect committed to sustainable and innovative urban design solutions.",
    projects: ["Smart City Planning", "Eco-friendly Residential Complex"],
    languages: ["English", "Kannada", "Hindi"],
    interests: ["Green Architecture", "Travel", "Classical Dance"],
    socialMedia: {
      linkedin: "linkedin.com/in/meeraiyer"
    }
  },
  {
    id: "10",
    fullName: "Neha Kapoor",
    email: "neha.kapoor@email.com",
    profileImage: "https://randomuser.me/api/portraits/women/10.jpg",
    graduationYear: 2012,
    major: "Marketing",
    university: "Indian School of Business, Hyderabad",
    company: "Hindustan Unilever",
    industry: "FMCG",
    currentPosition: "Brand Manager",
    location: "Mumbai, Maharashtra",
    skills: ["Brand Strategy", "Market Research", "Digital Marketing", "Content Development", "SEO"],
    achievements: "Led a marketing campaign that increased product sales by 40% in 6 months",
    bio: "Creative marketing professional with a passion for brand storytelling and consumer engagement.",
    projects: ["Digital Marketing Campaign for FMCG Product", "Brand Repositioning Strategy"],
    languages: ["English", "Hindi"],
    interests: ["Creative Writing", "Photography", "Cooking"],
    socialMedia: {
      linkedin: "linkedin.com/in/nehakapoor",
      twitter: "twitter.com/nehamarkets"
    }
  }
];

const AlumniProfilePage = () => {
  const { id } = useParams();
  const alumni = enhancedAlumniData.find(user => user.id === id);
  const [showAIInsights, setShowAIInsights] = useState(false);
  const [aiLoading, setAILoading] = useState(false);
  const [matchingScore, setMatchingScore] = useState(0);

  useEffect(() => {
    // Simulating a matching score calculation
    const calculatedScore = Math.floor(Math.random() * 41) + 60; // Random score between 60 and 100
    setMatchingScore(calculatedScore);
  }, []);

  if (!alumni) {
    return <div>Alumni not found</div>;
  }

  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.3 } }
  };

  const handleAIInsights = () => {
    setAILoading(true);
    setTimeout(() => {
      setShowAIInsights(true);
      setAILoading(false);
    }, 2000); // Simulating AI processing time
  };

  const AIInsightsPanel = () => (
    <motion.div
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: 'auto' }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.5 }}
      className="bg-blue-100 p-6 rounded-lg mt-8"
    >
      <h3 className="text-2xl font-bold mb-4 flex items-center">
        <FaRobot className="mr-2 text-blue-600" />
        AI-Powered Insights
      </h3>
      <div className="space-y-6">
        <div>
          <h4 className="text-xl font-semibold mb-2 flex items-center">
            <FaLightbulb className="text-yellow-500 mr-2" />
            Career Insights
          </h4>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>Based on {alumni.fullName}'s career trajectory, they are likely to advance to a {alumni.currentPosition.includes('Senior') ? 'leadership' : 'senior'} role within the next 2-3 years.</li>
            <li>Their expertise in {alumni.skills.slice(0, 3).join(', ')} aligns with growing industry trends, suggesting strong future demand for their skill set.</li>
          </ul>
        </div>
        <div>
          <h4 className="text-xl font-semibold mb-2 flex items-center">
            <FaHandshake className="text-green-500 mr-2" />
            Networking Opportunities
          </h4>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>{alumni.fullName} could be an excellent mentor for junior professionals in {alumni.industry}, particularly those interested in {alumni.interests[0]}.</li>
            <li>Their project on "{alumni.projects[0]}" aligns with current industry trends. Collaboration opportunities may exist with alumni working on similar initiatives.</li>
          </ul>
        </div>
        <div>
          <h4 className="text-xl font-semibold mb-2 flex items-center">
            <FaUniversity className="text-purple-500 mr-2" />
            Alumni Engagement
          </h4>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>Given their background in {alumni.major}, they could provide valuable insights for our upcoming alumni panel on emerging technologies.</li>
            <li>{alumni.fullName}'s experience at {alumni.company} makes them an ideal candidate for hosting a workshop on {alumni.skills[0]} for current students.</li>
          </ul>
        </div>
      </div>
    </motion.div>
  );

  const MatchingScorePanel = () => (
    <motion.div
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: 'auto' }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.5 }}
      className="bg-green-100 p-6 rounded-lg mt-8"
    >
      <h3 className="text-2xl font-bold mb-4 flex items-center">
        <FaPercentage className="mr-2 text-green-600" />
        Matching Score Breakdown
      </h3>
      <div className="space-y-4">
        <div>
          <div className="flex justify-between items-center mb-2">
            <span className="text-lg font-semibold">Overall Match</span>
            <span className="text-2xl font-bold text-green-600">{matchingScore}%</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2.5">
            <div className="bg-green-600 h-2.5 rounded-full" style={{ width: `${matchingScore}%` }}></div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <h4 className="text-lg font-semibold mb-2 flex items-center">
              <FaGraduationCap className="text-blue-500 mr-2" />
              Education Similarity
            </h4>
            <p className="text-gray-700">85% match in academic background</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2 flex items-center">
              <FaSuitcase className="text-indigo-500 mr-2" />
              Career Path Alignment
            </h4>
            <p className="text-gray-700">70% similarity in career trajectory</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2 flex items-center">
              <FaCogs className="text-red-500 mr-2" />
              Skill Set Overlap
            </h4>
            <p className="text-gray-700">90% match in key skills and competencies</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2 flex items-center">
              <FaIndustry className="text-yellow-500 mr-2" />
              Industry Relevance
            </h4>
            <p className="text-gray-700">80% alignment with your industry interests</p>
          </div>
        </div>
      </div>
    </motion.div>
  );

  return (
    <motion.div 
      className="min-h-screen bg-gradient-to-br from-blue-100 to-indigo-200 py-12 px-4 sm:px-6 lg:px-8"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <div className="max-w-6xl mx-auto">
        <Link to="/directory" className="inline-flex items-center text-indigo-600 hover:text-indigo-800 mb-6">
          <FaArrowLeft className="mr-2" />
          Back to Directory
        </Link>
        <motion.div className="bg-white shadow-2xl rounded-lg overflow-hidden" variants={itemVariants}>
          <div className="p-6 sm:p-10">
            <div className="flex flex-col lg:flex-row items-center mb-10">
              <motion.img 
                src={alumni.profileImage}
                alt={alumni.fullName}
                className="w-40 h-40 rounded-full mb-4 lg:mb-0 lg:mr-10 object-cover"
                whileHover={{ scale: 1.1 }}
              />
              <div className="text-center lg:text-left">
                <h1 className="text-4xl font-bold text-gray-900 mb-2">{alumni.fullName}</h1>
                <p className="text-2xl text-gray-600 mb-4">{alumni.currentPosition} at {alumni.company}</p>
                <div className="flex flex-wrap justify-center lg:justify-start gap-4">
                  {alumni.skills.map((skill, index) => (
                    <span key={index} className="bg-blue-100 text-blue-800 text-sm font-semibold px-3 py-1 rounded">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <motion.div variants={itemVariants} className="flex items-center">
                <FaGraduationCap className="text-3xl text-blue-500 mr-4" />
                <div>
                  <p className="text-sm text-gray-600">Education</p>
                  <p className="font-semibold">{alumni.major}, Class of {alumni.graduationYear}</p>
                </div>
              </motion.div>

              <motion.div variants={itemVariants} className="flex items-center">
                <FaIndustry className="text-3xl text-green-500 mr-4" />
                <div>
                  <p className="text-sm text-gray-600">Industry</p>
                  <p className="font-semibold">{alumni.industry}</p>
                </div>
              </motion.div>

              <motion.div variants={itemVariants} className="flex items-center">
                <FaMapMarkerAlt className="text-3xl text-red-500 mr-4" />
                <div>
                  <p className="text-sm text-gray-600">Location</p>
                  <p className="font-semibold">{alumni.location}</p>
                </div>
              </motion.div>

              <motion.div variants={itemVariants} className="flex items-center">
                <FaEnvelope className="text-3xl text-indigo-500 mr-4" />
                <div>
                  <p className="text-sm text-gray-600">Email</p>
                  <p className="font-semibold">{alumni.email}</p>
                </div>
              </motion.div>

              <motion.div variants={itemVariants} className="flex items-center">
                <FaUsers className="text-3xl text-yellow-500 mr-4" />
                <div>
                  <p className="text-sm text-gray-600">Languages</p>
                  <p className="font-semibold">{alumni.languages.join(', ')}</p>
                </div>
              </motion.div>

              <motion.div variants={itemVariants} className="flex items-center">
                <FaProjectDiagram className="text-3xl text-purple-500 mr-4" />
                <div>
                  <p className="text-sm text-gray-600">Notable Projects</p>
                  <p className="font-semibold">{alumni.projects[0]}</p>
                </div>
              </motion.div>
            </div>

            <motion.div variants={itemVariants} className="mt-12">
              <h2 className="text-2xl font-bold mb-4">About {alumni.fullName}</h2>
              <p className="text-gray-700 leading-relaxed">{alumni.bio}</p>
            </motion.div>

            <motion.div variants={itemVariants} className="mt-12">
              <h2 className="text-2xl font-bold mb-4">Achievements</h2>
              <div className="bg-gray-100 p-6 rounded-lg">
                <p className="text-gray-700">{alumni.achievements}</p>
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="mt-12">
              <h2 className="text-2xl font-bold mb-4">Interests</h2>
              <div className="flex flex-wrap gap-4">
                {alumni.interests.map((interest, index) => (
                  <span key={index} className="bg-green-100 text-green-800 text-sm font-semibold px-3 py-1 rounded">
                    {interest}
                  </span>
                ))}
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="mt-12">
              <h2 className="text-2xl font-bold mb-4">Connect with {alumni.fullName}</h2>
              <div className="flex flex-wrap gap-4">
                {alumni.socialMedia.linkedin && (
                  <a href={alumni.socialMedia.linkedin} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">
                    <FaLinkedin className="text-3xl" />
                  </a>
                )}
                {alumni.socialMedia.github && (
                  <a href={alumni.socialMedia.github} target="_blank" rel="noopener noreferrer" className="text-gray-800 hover:text-gray-600">
                    <FaGithub className="text-3xl" />
                  </a>
                )}
                {alumni.socialMedia.twitter && (
                  <a href={alumni.socialMedia.twitter} target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-600">
                    <FaTwitter className="text-3xl" />
                  </a>
                )}
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="mt-12 flex flex-wrap justify-center gap-4">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-blue-500 text-white px-8 py-3 rounded-full font-semibold flex items-center"
              >
                <FaUserPlus className="mr-2" />
                Connect
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-green-500 text-white px-8 py-3 rounded-full font-semibold flex items-center"
              >
                <FaComment className="mr-2" />
                Message
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-purple-500 text-white px-8 py-3 rounded-full font-semibold flex items-center"
                onClick={handleAIInsights}
                disabled={aiLoading}
              >
                <FaRobot className="mr-2" />
                {aiLoading ? 'Processing...' : 'Get AI Insights'}
              </motion.button>
            </motion.div>

            <AnimatePresence>
              {showAIInsights && (
                <>
                  <AIInsightsPanel />
                  <MatchingScorePanel />
                </>
              )}
            </AnimatePresence>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default AlumniProfilePage;